import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AmpDetalhadoService } from '../amp-detalhado-service/amp-detalhado.service';
import { Filtros } from './../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';

@Component({
  selector: 'app-amp-detalhado-detalhado-lista',
  templateUrl: './amp-detalhado-lista.component.html',
  styles: [`
      .text-right {
        text-align: right;
      } 
    `],
  styleUrls: ['./amp-detalhado-lista.component.css']
})
export class AmpDetalhadoListaComponent extends ListaBase implements OnInit {

  first = 0;
  rows = 10;
  carregando = false;
  parametrosFiltro: any;
  filtors: any = {};
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  cols: any[];
  _selectedColumns: any[];
  filtroconsolidado = false;
  filtropecas = true;
  filtroroupas = true;
  filtroacessorios = true;
  // titulo = 'PCA-CONSOLIDADO';
  tipo: any;
  data: any;
  tempDados: any;

  dadosTranslate = {
    "Nome": "estoque.ampDetalhado.nome",
    "Estoque": "estoque.ampDetalhado.estoque",
    "Manter": "estoque.ampDetalhado.manter",
    "Comprar": "estoque.ampDetalhado.comprar",
    "Brasil": "estoque.ampDetalhado.brasil"
  }

  constructor(service: AmpDetalhadoService,
    toast: ToastrService,
    router: Router,
    private exportExcel: ExportExcelService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private currency: CurrencyPipe,
    private number: DecimalPipe,
    private route: ActivatedRoute,
    private percent: PercentPipe) {
    super(service, toast, router);
    this.filtros = {};
    this.nomeModulo = 'amp-detalhado';
  }

  @Input() set carregar(valores: any[]) {
    if (valores.length > 0) {
      this.limparFiltros();
      valores.forEach(item => {
        new FiltroDealer(new FiltroEspecifico(null))
          .gerar(item, this.filtros);
      });
    } else {
      this.limparFiltros();
    }
    //this.buscar();
  }

  ngOnInit(): void {
    this.selecionaDealer();
    this.calculando();
    this.buscar();
    this.cols = [
      { field: 'part_number', header: 'Part Number' },
      { field: 'estoque', header: 'Estoque', type: this.number, arg1: '1.0-0' },
      { field: 'manter', header: 'Manter', type: this.number, arg1: '1.0-0' },
      { field: 'comprar', header: 'Comprar', type: this.number, arg1: '1.0-0' },
      { field: 'percentual', header: '%' },


    ];

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  selecionaDealer(){
    this.route.queryParams.subscribe(params => {
      const parametro = params['dealer'];  
      this.filtros = { dealer: parametro };
    });
    
  }

 
  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.service.buscar(objFiltro).then(res => {
      this.tempDados = res;
      
      this.tempDados.dados.forEach(item => {
        item.percentual = item.percentual * 100 + '%'
      });
    });

  }
  calculando() {
    this.tempDados = {
      dados: [
        {
          "codigo_dealer": 0,
          "nome_dealer": "Calculando..",
          "custo": 0,
          "varejo": 0,
          "obsoletos": 0,
          "percentual": 0,
          "media_mensal_varejo": 0,
          "mos": 0,
          "giro": 0
        },
        {
          "codigo_dealer": 0,
          "nome_dealer": "Calculando..",
          "custo": 0,
          "varejo": 0,
          "obsoletos": 0,
          "percentual": 0,
          "media_mensal_varejo": 0,
          "mos": 0,
          "giro": 0
        }
      ],
      total: [
        {
          "nome_dealer": "Brasil",
          "qtd_dealer": 0,
          "custo": 0.0,
          "varejo": 0,
          "obsoletos": 0,
          "percentual": 0,
          "media_mensal_varejo": 0,
          "mos": 0,
          "giro": 0
        }
      ]
    }
  }
  

  protected getListagemComFiltros(): boolean {
    return this.filtros.data_inicial
      || this.filtros.data_final
  }

  limparFiltros(): any {
    this.filtros.dealers = '';
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcelJSON(this.tempDados.dados.map(r => {
      let linha = {};

      this._selectedColumns.forEach(c => {
        linha[this.translateHeader(c.header)] = r[c.field]
      });
      
      return linha;
    }));
  }

  translateHeader(item){
    if(item == "Estoque"){
      return this.translate.currentLang == "br" ? "Estoque" : "Inventory";
    }
    if(item == "Manter"){
      return this.translate.currentLang == "br" ? "Manter" : "Keep";
    }
    if(item == "Comprar"){
      return this.translate.currentLang == "br" ? "Comprar" : "Purchase";
    }

    return item;
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  ngAfterViewChecked() {
    if (this.translate.currentLang === 'gb') {
      this.translate.use('br');
      this.translate.use('gb');
    }
    this.getTranslate('');
    this.cdRef.detectChanges();
  }

  voltar() {
    this.router.navigateByUrl('estoque/amp');
  }

  // Paginação
  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.service ? this.first === (this.service.length - this.rows) : true;
  }

  isFirstPage(): boolean {
    return this.service ? this.first === 0 : true;
  }

}

abstract class GerarFiltro {
  proximoGerador: GerarFiltro;

  constructor(proximoGerador: GerarFiltro) {
    this.proximoGerador = proximoGerador;
  }
  public abstract gerar(item: any, filtros: any);

}

class FiltroDealer extends GerarFiltro {
  public gerar(item: any, filtros: any) {
    if (item.chave === 'dealers') {
      const itens: string[] = [];
      item.valor.forEach(element => {
        itens.push(element);
      });
      filtros.dealers = itens;
    } else {
      this.proximoGerador.gerar(item, filtros);
    }

  }


}

class FiltroEspecifico extends GerarFiltro {
  public gerar(item: any, filtros: any) {
    filtros[item.chave] = item.valor;
  }

}
